<template>
    <ib-dialog v-model="isOpen" overlay-opacity="0.5" overlay-color="black" max-width="450" persistent>
        <v-card>
            <ib-dialog-header title="Editar nome" subtitle="Altere o nome do contato por aqui" :close="cancelEdit" />
            <v-card-text>
                <ib-text-field 
                    v-model="localName" 
                    class="pt-1" 
                    label="Novo nome do contato" 
                    outlined 
                    hide-details="auto" 
                    @keyup.enter="changeContactName()" 
                />
            </v-card-text>
            <v-card-actions>
                <ib-btn outlined color="gray200" @click="cancelEdit">
                    <div class="gray1000--text">
                        Cancelar
                    </div>
                </ib-btn>
                <v-spacer />
                <ib-btn dark color="primary" @click="changeContactName()">
                    Salvar
                </ib-btn>
            </v-card-actions>
        </v-card>
    </ib-dialog>
</template>

<script>
import Api from "@/lib/Api";
import { emitToastr } from "@/lib/Utils";
export default {
    props: {
        value: Boolean,
        contact: Object
    },
    data() {
        return {
            localName: ""
        };
    },
    watch: {
        contact: {
            handler(newVal) {
                if (newVal) {
                    this.localName = newVal.override_name || newVal.name;
                }
            }
        }
    },
    computed: {
        isOpen: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit("input", val);
            }
        }
    },
    methods: {
        cancelEdit() {
            this.localName = this.contact?.override_name || this.contact?.name;
            this.isOpen = false;
        },
        async changeContactName() {
            if (!this.contact) return;

            const updatedContact = {
                ...this.contact,
                override_name: this.localName
            };
            const resp = await Api.changeContactName(updatedContact);
            if (!resp.error) emitToastr("success", "Nome atualizado");
            this.isOpen = false;
        }
    }
};
</script>